<template>
 <v-layout row justify-center fill-height align-center>
    <v-flex xs12>
      <v-card class="ma-3">

        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
            >
              {{ $t(item.header) }}
            </v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-tile
              v-else
              :key="item.title"
              avatar
            >
              <v-list-tile-avatar>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="$t(item.title)"></v-list-tile-title>
                <v-list-tile-sub-title v-html="$t(item.subtitle)"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      items: [
        { header: 'help.sections.standby.title' },
        {
          title: 'help.sections.standby.normal-working-mode.title',
          subtitle: 'help.sections.standby.normal-working-mode.description',
          icon: 'info'
        },
        {
          title: 'help.sections.standby.cloud-connection-state.title',
          subtitle: 'help.sections.standby.cloud-connection-state.description',
          icon: 'info'
        },
        { header: 'help.sections.wps.title' },
        {
          title: 'help.sections.wps.step1.title',
          subtitle: 'help.sections.wps.step1.description',
          icon: 'info'
        },
        {
          title: 'help.sections.wps.step2.title',
          subtitle: 'help.sections.wps.step2.description',
          icon: 'info'
        },
        {
          title: 'help.sections.wps.step3.title',
          subtitle: 'help.sections.wps.step3.description',
          icon: 'info'
        },
        {
          title: 'help.sections.wps.step4.title',
          subtitle: 'help.sections.wps.step4.description',
          icon: 'info'
        },
        {
          title: 'help.sections.wps.step5.title',
          subtitle: 'help.sections.wps.step5.description',
          icon: 'info'
        },
        {
          title: 'help.sections.wps.step6.title',
          subtitle: 'help.sections.wps.step6.description',
          icon: 'info'
        }

      ]
    }
  }
}
</script>
